<template>
  <div class="form-container">
    <div class="wrapper">
      <field :detail="detail" />
    </div>
    <div>
      <b-card no-body>
        <b-tabs content-class="mt-3" fill>
          <b-tab title="Equipment List" active>
            <b-row>
              <b-col cols="6" />
              <b-col cols="3">
                <b-form-group label="" label-size="sm" label-class="font-weight-bold">
                  <b-form-checkbox
                    size="sm"
                    v-model="detail.is_need_exchange_req"
                    :disabled="true"
                  >
                    Need Exchange Rate
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  label-size="sm"
                  class="flex-fill m-0 mr-2 position-relative"
                >
                  <b-input-group size="sm">
                    <template #prepend>
                      <b-input-group-text class="bg-transparent col-form-label col-form-label-sm font-weight-bold input-group-text-disabled">
                        Rate
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      autocapitalize="off"
                      autocomplete="off"
                      v-model="detail.rate_req"
                      min="0"
                      type="number"
                      :disabled="true"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              thead-class="bg-color text-center"
              empty-text="No data"
              :items="detail.equipment"
              :fields="fields"
              show-empty
              responsive
            >
              <template v-slot:cell(name)="{ item }">
                <b-form-input v-model="item.type.name" size="sm" disabled />
              </template>

              <template v-slot:cell(units)="{ item }">
                <div class="d-flex mb-2" v-for="(unit, u) of item.units" :key="u">
                  <b-form-input
                    autocapitalize="off"
                    :value="unit.name"
                    size="sm"
                    disabled
                  />
                </div>
              </template>

              <template v-slot:cell(base_rate_hours)="{ item }">
                <b-form-input
                  autocapitalize="off"
                  v-model="item.base_rate_hours"
                  size="sm"
                  disabled
                />
              </template>

              <template v-slot:cell(base_rate_hours_2)="{ item }">
                <b-form-input
                  autocapitalize="off"
                  v-model="item.base_rate_hours_2"
                  size="sm"
                  disabled
                />
              </template>

              <template v-slot:cell(fuel_const)="{ item }">
                <b-form-input
                  autocapitalize="off"
                  v-model="item.fuel_const"
                  size="sm"
                  disabled
                />
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Volume Work">
            <b-row>
              <b-col cols="6" />
              <b-col cols="3">
                <b-form-group label="" label-size="sm" label-class="font-weight-bold">
                  <b-form-checkbox
                    size="sm"
                    v-model="detail.is_need_exchange"
                    :disabled="true"
                  >
                    Need Exchange Rate
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  label-size="sm"
                  class="flex-fill m-0 mr-2 position-relative"
                >
                  <b-input-group size="sm">
                    <template #prepend>
                      <b-input-group-text class="bg-transparent col-form-label col-form-label-sm font-weight-bold input-group-text-disabled">
                        Rate
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      autocapitalize="off"
                      autocomplete="off"
                      v-model="detail.rate"
                      min="0"
                      type="number"
                      :disabled="true"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              thead-class="bg-color text-center"
              empty-text="No data"
              :items="detail.contractorVolumeWork"
              :fields="volumeWorkFields"
              show-empty
              v-show="detail.is_volume_work === true"
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center my-4">
                  <b-spinner variant="info" class="spinner-lg" />
                </div>
              </template>

              <template v-slot:cell(item)="{ item }">
                <b-form-select
                  v-model="item.rate_type_id"
                  value-field="id"
                  text-field="type_name"
                  size="sm"
                  :options="volumeItems"
                  disabled
                />
              </template>

              <template v-slot:cell(coalBasePrice)="{ item }">
                <div class="d-flex mb-2" v-for="(data, u) of item.rates" :key="u">
                  <b-form-input
                    autocapitalize="off"
                    :value="data.coalBasePrice.name"
                    size="sm"
                    disabled
                  />
                </div>
              </template>

              <template v-slot:cell(volume_work_from)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.volume_work_from"
                    size="sm"
                    type="number"
                    min="0"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(volume_work_to)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.volume_work_to"
                    size="sm"
                    type="number"
                    min="0"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(base_rate_volume_bcm)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.base_rate_volume_bcm"
                    size="sm"
                    type="number"
                    min="0"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(base_rate_hours)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.base_rate_hours"
                    type="number"
                    size="sm"
                    min="0"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(unit)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    :value="item.rate_type_id ? `IDR/${volumeItems.find(v => v.id === item.rate_type_id).unit}` : ''"
                    size="sm"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(fuel_const)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.fuel_const"
                    type="number"
                    step="0.01"
                    size="sm"
                    min="0"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
              <template v-slot:cell(divisor)="{ item }">
                <div
                  class="d-flex mb-2"
                  v-for="(data, u) of item.rates"
                  :key="u"
                >
                  <b-form-input
                    autocapitalize="off"
                    v-model="data.divisor"
                    size="sm"
                    type="number"
                    autocomplete="off"
                    disabled
                  />
                </div>
              </template>
            </b-table>
            <div class="px-3 py-5 text-center" v-show="!detail.is_volume_work">
              <img
                src="@/assets/icon-contractor-work-volume.png"
                alt=""
                width="120"
                height="120"
              />
              <p class="text-muted mb-5">
                This feature can be active if contractor have volume work in
                contract
              </p>
            </div>
          </b-tab>
          <b-tab title="Employee List">
            <b-table
              thead-class="bg-color text-center"
              empty-text="No data"
              :items="contractorEmployee"
              :fields="employeeFields"
              show-empty
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center my-4">
                  <b-spinner variant="info" class="spinner-lg" />
                </div>
              </template>
              <template v-slot:cell(action)="items">
                <b-button
                  class="btn-custom mr-2"
                  variant="info"
                  size="sm"
                  @click="showDetailEmployee(items.item)"
                  >Detail</b-button
                >
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Explosive Rate">
            <b-row>
              <b-col cols="6" />
              <b-col cols="3">
                <b-form-group label="" label-size="sm" label-class="font-weight-bold">
                  <b-form-checkbox
                    size="sm"
                    v-model="detail.is_need_exchange_other"
                    :disabled="true"
                  >
                    Need Exchange Rate
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  label-size="sm"
                  class="flex-fill m-0 mr-2 position-relative"
                >
                  <b-input-group size="sm">
                    <template #prepend>
                      <b-input-group-text class="bg-transparent col-form-label col-form-label-sm font-weight-bold input-group-text-disabled">
                        Rate
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      autocapitalize="off"
                      autocomplete="off"
                      v-model="detail.rate_other"
                      min="0"
                      type="number"
                      :disabled="true"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              thead-class="bg-color text-center"
              empty-text="No data"
              :items="detail.otherRates"
              :fields="otherRateFields"
              show-empty
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center my-4">
                  <b-spinner variant="info" class="spinner-lg" />
                </div>
              </template>
              <template v-slot:cell(rate)="data">
                {{ formatMoney(parseFloat(data.value), { symbol: '', precision: '2', thousand: ',' }) }}
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Additional Rate">
            <b-row>
              <b-col cols="6" />
              <b-col cols="3">
                <b-form-group label="" label-size="sm" label-class="font-weight-bold">
                  <b-form-checkbox
                    size="sm"
                    v-model="detail.is_need_exchange_additional"
                    :disabled="true"
                  >
                    Need Exchange Rate
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  label-size="sm"
                  class="flex-fill m-0 mr-2 position-relative"
                >
                  <b-input-group size="sm">
                    <template #prepend>
                      <b-input-group-text class="bg-transparent col-form-label col-form-label-sm font-weight-bold input-group-text-disabled">
                        Rate
                      </b-input-group-text>
                    </template>
                    <b-form-input
                      autocapitalize="off"
                      autocomplete="off"
                      v-model="detail.rate_additional"
                      min="0"
                      type="number"
                      :disabled="true"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              thead-class="bg-color text-center"
              empty-text="No data"
              :items="detail.additionalRates"
              :fields="additionalRateFields"
              show-empty
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center my-4">
                  <b-spinner variant="info" class="spinner-lg" />
                </div>
              </template>
              <template v-slot:cell(rate)="data">
                {{ formatMoney(parseFloat(data.value), { symbol: '', precision: '2', thousand: ',' }) }}
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div class="d-flex mt-5">
      <b-button
        class="btn-reset mr-2 ml-auto"
        variant="outline-info"
        size="sm"
        @click="onClickBack"
      >
        Back
      </b-button>
      <b-button
        v-if="canEdit"
        class="btn-custom"
        variant="info"
        size="sm"
        @click="onClickEdit"
      >
        Edit
      </b-button>
    </div>
    <modal-view :employee="employee" @reset="resetPassword" @editData="onRowEdit" />
    <modal-successful :message="text" />
    <modal-create
      @submit="submitEmployee"
      :form.sync="employee"
      :division="employee.division"
      :isEdit="isEdit"
      :company="companies"
      :error="error"
    />
  </div>
</template>

<script>
import Field from './Field'
import api from '@/api'
import ModalView from '../Employee/ModalView'
import ModalCreate from '../Employee/ModalCreate'
import ModalSuccessful from '@/partials/ModalSuccessful'
import { hasPermission } from '@/utils/permissions'
import { CONTRACTOR_EDIT } from '@/fixtures'
import { formatMoney } from 'accounting-js'

export default {
  components: {
    Field,
    ModalView,
    ModalCreate,
    ModalSuccessful
  },

  data: () => ({
    canEdit: hasPermission(CONTRACTOR_EDIT),
    isEdit: false,
    companies: [],
    text: '',
    fields: [
      { key: 'name', label: 'Type', tdClass: 'text-center' },
      { key: 'units', label: 'Unit', tdClass: 'text-center' },
      { key: 'base_rate_hours', label: 'Price A (<= 70)', tdClass: 'text-center' },
      { key: 'base_rate_hours_2', label: 'Price B (> 70)', tdClass: 'text-center' },
      { key: 'fuel_const', label: 'Fuel Cons', tdClass: 'text-center' },
      { key: 'actions', label: '', tdClass: 'text-center' }
    ],
    volumeWorkFields: [
      {
        key: 'item',
        label: 'Item',
        tdClass: 'text-center'
      },
      {
        key: 'coalBasePrice',
        label: 'Coal Best Price ($)',
        tdClass: 'text-center'
      },
      {
        key: 'volume_work_from',
        label: 'Distance (From) ',
        tdClass: 'text-center'
      },
      {
        key: 'volume_work_to',
        label: 'Distance (To)',
        tdClass: 'text-center'
      },
      {
        key: 'base_rate_volume_bcm',
        label: 'Base Rate Volume / BCM',
        tdClass: 'text-center'
      },
      {
        key: 'unit',
        label: 'Unit',
        tdClass: 'text-center'
      },
      {
        key: 'fuel_const',
        label: 'Fuel Cons',
        tdClass: 'text-center'
      },
      {
        key: 'divisor',
        label: 'Divisor',
        tdClass: 'text-center'
      }
    ],
    employeeFields: [
      { key: 'fullname', tdClass: 'text-center' },
      { key: 'position', tdClass: 'text-center' },
      { key: 'action', tdClass: 'text-center' }
    ],
    otherRateFields: [
      { key: 'description', label: 'Description' },
      { key: 'code', label: 'Code', tdClass: 'text-center' },
      { key: 'rate', label: 'Rate', tdClass: 'text-center' },
      { key: 'unit', label: 'Unit', tdClass: 'text-center' }
    ],
    additionalRateFields: [
      { key: 'description', label: 'Description' },
      { key: 'unit', label: 'Unit', tdClass: 'text-center' },
      { key: 'rate', label: 'Rate', tdClass: 'text-center' },
      { key: 'fuel_cons', label: 'Fuel Cons', tdClass: 'text-center' },
      { key: 'actions', label: '', tdClass: 'text-center' }
    ],
    detail: {
      name: '',
      contract_number: '',
      email: '',
      phone: '',
      address: '',
      company_id: 0,
      is_need_exchange: false,
      is_need_exchange_req: false,
      is_need_exchange_other: false,
      is_active: false,
      contract_periode_start: '',
      contract_periode_end: '',
      company: [],
      equipment: [],
      contractorVolumeWork: [],
      otherRates: []
    },
    contractorEmployee: [],
    employee: {},
    company: [],
    error: '',
    volumeItems: []
  }),

  created() {
    this.fetchDetailContractor()
    this.fetchEmployee()
    this.fetchRateType()
    this.fetchCompany()
  },

  methods: {
    formatMoney,
    async fetchDetailContractor() {
      const data = await api.contractor.get(this.$route.params.id)
      this.detail = data
    },
    async fetchEmployee() {
      const { data } = await api.employee.list({
        filter_value: `contractor_id:${this.$route.params.id}`,
        page: this.currentPage,
        limit: this.perPage,
        direction: this.sortDesc ? 'desc' : 'asc',
        company_id: '',
        search: ''
      })
      this.contractorEmployee = data.users
    },
    async fetchCompany() {
      this.companies = await api.company.list_active()
    },
    async fetchRateType() {
      this.volumeItems = await api.contractor.rateType()
    },
    onClickBack() {
      this.$router.push({ path: '/contractor' })
    },
    onClickEdit() {
      this.$router.push({ path: `/contractor/${this.$route.params.id}/edit` })
    },
    showDetailEmployee(value) {
      this.employee = value
      this.$bvModal.show('modal-view')
    },
    async submitEmployee(form) {
      try {
        this.employee = {}
        this.employee.department = form.department === '' ? null : form.department
        this.employee.department_id = form.department_id ?? null
        this.employee.division_name = form.division ? (form.division.name === '' ? null : form.division.name) : null
        this.employee.division_id = form.division_id ?? null
        this.employee.is_active_directory = form.is_active_directory ? form.is_active_directory : false
        this.employee.is_active = true
        this.employee.need_activation = false
        this.employee.username = form.username
        this.employee.fullname = form.fullname
        this.employee.role_id = form.role_id
        this.employee.company_id = form.company_id
        this.employee.contractor_id = form.contractor_id ? form.contractor_id : 0
        this.employee.email = form.email
        this.employee.phone = form.phone ? form.phone : null
        this.employee.password = form.password
        this.employee.is_contractor = form.is_contractor ? form.is_contractor : false
        if (this.isEdit) {
          await api.employee.update(form.id, this.employee)
          this.text = 'edited the employee'
          this.$bvModal.show('modal-successful')
        }
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(
            `Error ${response.status} - ${response.data.error.message}`,
            {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            }
          )
        })
      }
    },
    onRowEdit(data) {
      this.isEdit = true
      this.error = ''
      this.employee = data
      if (!this.employee.division) {
        this.employee.division = {
          name: null
        }
      }
      this.employee.is_contractor = data.contractors !== null
      this.$bvModal.show('modal-create')
    },
    async resetPassword(id) {
      try {
        await api.employee.resetPassword(id)
        this.text = 'reset password'
        this.$bvModal.show('modal-successful')
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(
            `Error ${response.status} - ${response.data.error.message}`,
            {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            }
          )
        })
      }
    }
  },

  destroyed() {
    localStorage.removeItem('currentPage', this.currentPage)
    localStorage.removeItem('totalRows', this.totalRows)
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}

.col-form-label,
.col-form-label-sm {
  font-size: 12px !important;
}

.input-group-text-disabled {
  background-color: #e9ecef !important;
  opacity: 1;
}
</style>
